module.exports = __webpack_public_path__ + "img/ln5.678bbd06.jpeg";